import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, ContainerNome, HeaderTitle, SubContainerButton, StyledUni, StyledEndereco, ContainerEndereco,  DivHorario, ContainerContentHorarios, ContainerImage, ContainerImgClock, Body } from './style'
import Button from '../../components/Button/Button'
import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarker, faMapMarked } from '@fortawesome/free-solid-svg-icons'
import logo from '../../assets/images/logo.png'
import ImgClock from '../../assets/images/clock-protocolo.png'
import ImgExclamacao from '../../assets/images/exclamacao-icon_2_.png'
import disableBrowserBackButton from 'disable-browser-back-navigation'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { callGeolocation, checkGeolocation } from '../../helpers/geo'
import LinkButton from '../../components/LinkButton/LinkButton'
import { fetchCheckGeoStart, checkGeoReset }  from '../../services/store/reducers/endpoints/checkGeo'
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo'
import { fetchFindCoordsByUnitStart, findCoordsByUnitReset }  from '../../services/store/reducers/endpoints/findCoordsByUnit'

class ConfigurationPoint extends PureComponent{
  
  state = {
    sended: false,
    sendedFindCoordsByUnit: false,
    distancia: '...'
  }

  UNSAFE_componentWillMount () {
    this.setState({sendedFindCoordsByUnit: true})
    this.props.findCoordsByUnitReset()
    this.props.fetchFindCoordsByUnitStart({unit: this.props.registerPoint.codUnidade})
    disableBrowserBackButton()
    console.log('reducers', this.props.registerPoint)
  }

  diff_minutes = (dt2, dt1) => {
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  toLoginUser = () => {
    if (!window.navigator.onLine) {
      window.location.href='/report-user?message=-&errorCode=1'
    
      return
    }
    this.resposta()
    return
    /*const { registerPoint }       = this.props
    const tipo                    = registerPoint.tipo
    const horarioEntrada          = registerPoint.horarioEntrada
    const horarioSaida            = registerPoint.horarioSaida
    const toleranciaAntecipacao   = registerPoint.toleranciaAntecipacao
    const toleranciaAtraso        = registerPoint.toleranciaAtraso

    let dataAgora = new Date()
    let dataEntrada = new Date()
    let dataSaida = new Date()

    const entradaPieces = horarioEntrada.split(':')
    dataEntrada.setHours(entradaPieces[0])
    dataEntrada.setMinutes(entradaPieces[1])
    dataEntrada.setSeconds(entradaPieces[2])

    const saidaPieces = horarioSaida.split(':')
    dataSaida.setHours(saidaPieces[0])
    dataSaida.setMinutes(saidaPieces[1])
    dataSaida.setSeconds(saidaPieces[2])

    console.log(dataAgora, '--', dataEntrada, '--',dataSaida)

    if(tipo === 'Entrada') {
      const diferenca = this.diff_minutes(dataAgora, dataEntrada)

      console.log('diferenca', diferenca)
      if(dataEntrada.getTime() > dataAgora.getTime()){
        if(diferenca > toleranciaAntecipacao){
          alert('Não é possível registrar o ponto antes de ' + toleranciaAntecipacao + ' minutos do horário de entrada.')
        }else{
          this.sendCheckGeo()
        }
      }else{
        if(diferenca > toleranciaAtraso){
          alert('Não é possível registrar o ponto com mais de ' + toleranciaAtraso + ' minutos de atraso.')
        }else{
          this.sendCheckGeo()
        }
      }
    }
    if(tipo === 'Saida') {
      const diferenca = this.diff_minutes(dataAgora, dataSaida)

      console.log('diferenca', diferenca)
      if(dataSaida.getTime() > dataAgora.getTime()){
        if(diferenca > toleranciaAntecipacao){
          alert('Não é possível registrar o ponto antes de ' + toleranciaAntecipacao + ' minutos do horário de saída.')
        }else{
          this.sendCheckGeo()
        }
      }else{
        if(diferenca > toleranciaAtraso){
          alert('Não é possível registrar o ponto com mais de ' + toleranciaAtraso + ' minutos de atraso na saída.')
        }else{
          this.sendCheckGeo()
        }
      }
    }*/
    
    
  }

  sendCheckGeo = () => {
    this.props.checkGeoReset()
    this.setState({ sended: true })
    setTimeout(() => {
      this.props.fetchCheckGeoStart()
    }, 600)
    
  }

  resposta = () => {
    this.setState({ sended: false })
    //-22.801468, -45.705638
    
    checkGeolocation().then((result) => {
      if(result){
        window.location.href = '/login-user?to=login'
      }else{
        this.props.fetchRegistrarInfoStart({          
          "RE": this.props.registerPoint.re,
          "Empresa": this.props.home.company,
          "Cliente": this.props.registerPoint.codCliente,
          "Unidade": this.props.registerPoint.codUnidade,
          "Detalhes": "Usuário não está com GPS habilitado."
        })
        window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
      }
    })
    
    
    
  }

  voltar = () => {
    if (!window.navigator.onLine) {
      window.location.href='/report-user?message=-&errorCode=1'
      return
    }
    window.location.href = '/point-flow'
  }

  respostaFindCoordsByUnit = () => {
    let { latitude, longitude } = this.props.sagaFindCoordsByUnit
    this.setState({sendedFindCoordsByUnit: false})
    
    //callGeolocation(latitude, longitude, (position, distancia) => {
      this.setState({distancia: 0})
    //})
  }

  render() {
    const { sagaFindCoordsByUnit, sagaCheckGeo, registerPoint } = this.props

    console.log('registerPoint-->', registerPoint)

    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
          </ContainerImage>
       
        <CurrentTime></CurrentTime>
        <ContainerImgClock>
        {
          this.props.registerPoint.codCliente && 
          <LinkButton link='login-user?to=protocol'>
            <Image src={ImgClock} />
          </LinkButton>
           
        }
        
        </ContainerImgClock>
        <Body>
          <ContainerNome>
            <HeaderTitle>{ registerPoint && registerPoint.name }</HeaderTitle>
          </ContainerNome>
          <ContainerContentHorarios>
            <DivHorario acao={this.props.pointFlow.tipo ? this.props.pointFlow.tipo === '0' : false}>
              <div>Horário de entrada</div>
              <div>{ registerPoint ? registerPoint.horarioEntrada.substr(0, 5) : ' - ' }</div>
            </DivHorario>
            <DivHorario acao={this.props.pointFlow.tipo ? this.props.pointFlow.tipo === '1' : false}>
              <div>Horário de saída </div>
              <div>{ registerPoint ? registerPoint.horarioSaida.substr(0, 5)  : ' - ' }</div>
            </DivHorario>
            {
              registerPoint.horarioIntervalo &&
              <DivHorario acao={this.props.pointFlow.tipo ? (this.props.pointFlow.tipo === '2' || this.props.pointFlow.tipo === '3') : false}>
                <div>Horário de intervalo</div>
                <div>{ registerPoint ? registerPoint.horarioIntervalo.substr(0, 5) : ' - ' }</div>
              </DivHorario>
            }
            <ContainerEndereco>
              <br></br>
              {
                this.props.registerPoint.codCliente && 
                this.props.registerPoint.endereco.length > 0 ?
                
                <>
                  <StyledUni>
                    LOCALIZAÇÃO
                    </StyledUni>

                    <StyledEndereco color={'#ffc26c'}> 
                    <FontAwesomeIcon style={{ marginRight: '10px', color: '#FFF'}}onClick={this.handleClick} icon={faMapMarker} />
                    { registerPoint.endereco }
                  </StyledEndereco>
                </>
                :
                <div style={{display: 'flex',  alignItems: 'center', flexDirection: 'column' }}>
                  <StyledEndereco color={'#ffc26c'}> 
                    Sua alocação está pendente na mesa de operações.
                  </StyledEndereco>

                  <Image style={{marginTop: 20}} src={ImgExclamacao} />
                </div>
              }
              
            
              {
                this.props.appConfig.geoLocalizacao &&
                this.props.registerPoint?.endereco?.length > 0 &&
                <StyledEndereco color={'#ffc26c'}> 
               <FontAwesomeIcon style={{ marginRight: '10px', color: '#FFF'}}onClick={this.handleClick} icon={faMapMarked} />
                Posição aproximada: { this.state.distancia.toString().split('.')[0] } metro(s)
               </StyledEndereco>
              }
               


             </ContainerEndereco>
          </ContainerContentHorarios>
          
        </Body>
        <SubContainerButton>
          <Button width='130px' backgroundColor='#40bbca' onClick={() => { this.voltar() }}>Voltar</Button>
          <Button width='130px'  backgroundColor='#40bbca' onClick={() => { this.toLoginUser() }} >Registrar Ponto</Button>
        </SubContainerButton>
        {
          sagaCheckGeo &&
          this.state.sended &&
          this.resposta()
        }
        {
          sagaFindCoordsByUnit &&
          this.state.sendedFindCoordsByUnit &&
          this.respostaFindCoordsByUnit()
        }
        {
          //para colocar os pop up
          this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
       
           <ModalAlert>
             title={this.state.titleModal} 
             message={ this.state.messageModal} 
             onClick={() => { this.setState({messageModal: '', titleModal: ''}) } }
            </ModalAlert>
          
        }
        
     </Container>
    )
  }
}



const mapStateToProps = state => ({
  home: state.home,
  registerPoint: state.registerPoint,
  sagaRegisterPoint: state.sagaRegisterPoint.data,
  sagaCheckGeo: state.sagaCheckGeo.data,
  sagaFindCoordsByUnit: state.sagaFindCoordsByUnit.data,
  pointFlow: state.pointFlow,
  appConfig: state.appConfig
})

const mapDispatchToProps = dispatch => ({
  fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value)),
  fetchCheckGeoStart: (mss) => dispatch(fetchCheckGeoStart(mss)),
  checkGeoReset: () => dispatch(checkGeoReset()),
  fetchFindCoordsByUnitStart: (mss) => dispatch(fetchFindCoordsByUnitStart(mss)),
  findCoordsByUnitReset: () => dispatch(findCoordsByUnitReset()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigurationPoint)
